

import { FC } from 'react';
import { ErrorPage } from 'shared/pages/error/ErrorPage';

export const ErrorNotAllowedGeneric: FC = () => {
    return <ErrorPage
        title="Not allowed"
        text="You do not have enough permissions"
    />
};


import { FC } from 'react';
import { ErrorPage } from 'shared/pages/error/ErrorPage';

export const ErrorNotAllowedGeneric: FC = () => {
    return <ErrorPage
        title="Not allowed"
        text="You do not have enough permissions"
    />
};
